<template>
  <nav class="navbar-expand" :class="{ theme2: theme == 1 }">
    <ul class="navbar-nav">
      <li
        v-for="(item, index1) in data"
        :key="index1"
        class="nav-item menu-item has-children"
        :class="{ 'nav-main-page': index1 === 0, 'nav-theme2': theme == 1 }"
      >
        <router-link
          v-if="item.link == null"
          :target="item.new_tab == 1 ? '_blank' : '_parent'"
          :to="
            $router.resolve(
              findUrl(
                item.linkable_type,
                item.linkable_id,
                item.slug,
                item.link
              )
            ).href
          "
          class="nav-link px-3 pb-0"
        >
          <span class="fontsize-small weight-light"> {{ item.title }}</span>
          <svg
            v-if="item.children.length > 0"
            class="icon mr-2"
            width="10"
            height="10"
            fill="#222"
          >
            <use href="@/assets/svgIcons/svgIcons.svg/#arrow-down2"></use>
          </svg>
        </router-link>
        <a
          v-else-if="item.link != null"
          class="nav-link px-3 pb-0"
          :target="item.new_tab == 1 ? '_blank' : '_parent'"
          :href="item.link"
        >
          <span class="fontsize-small weight-light"> {{ item.title }}</span>
          <svg v-if="item.children.length > 0"
            class="icon mr-2"
            width="10"
            height="10"
            fill="#222"
          >
            <use href="@/assets/svgIcons/svgIcons.svg/#arrow-down2"></use>
          </svg>
        </a>

        <ul
          v-if="item.children.length > 0"
          class="navbar-nav d-flex flex-column"
        >
          <li
            v-for="(value, index) in item.children"
            :key="index"
            class="nav-item"
          >
            <router-link
                  v-if="item.link == null"
          :target="item.new_tab == 1 ? '_blank' : '_parent'"
          :to="
            $router.resolve(
              findUrl(
                item.linkable_type,
                item.linkable_id,
                item.slug,
                item.link
              )
            ).href
          "
              class="nav-link nav-link-child fontsize-mini weight-light"
              >{{ value.title }}</router-link
            >
            <a
                      v-else-if="item.link != null"
          :target="item.new_tab == 1 ? '_blank' : '_parent'"
          :href="item.link"
              class="nav-link nav-link-child fontsize-mini weight-light"
              >{{ value.title }}</a
            >
            
          </li>
          <!--          <li class="nav-item"><a class="nav-link fontsize-mini text-color-666 weight-light" href="">درباره ی ما </a></li>-->
          <!--          <li class="nav-item"><a class="nav-link fontsize-mini text-color-666 weight-light" href="">تماس با ما</a></li>-->
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import findUrl from "@/libraries/links/LinkResolver";

export default {
  name: "Navbar",
  props: {
    data: Array,
    theme: {
      default: 0,
      type: Number
    },
    
  },
  data() {
    return {
      menu: ["صفحه نخست", "وبلاگ", "گالری تصاویر", "سایر"],
      subOthers: ["وبلاگ", " درباره ما", " تماس با ما"]
    };
  },
   methods: {
    findUrl,
  },
  mounted() {
    // const navItem2 = document.querySelectorAll('.nav-item2');
    // const navMainPageLine = document.querySelectorAll('.nav-main-page .nav-bottom-line')[0];
    //
    //
    //
    // if (!(navMainPageLine.classList.contains('scaleX-0'))){
    //   navItem2.forEach(item=>{
    //     item.addEventListener('mouseover',function (){
    //       navMainPageLine.classList.add('scaleX-0');
    //     });
    //     item.addEventListener('mouseout',function (){
    //       navMainPageLine.classList.remove('scaleX-0');
    //     });
    //   });
    // }
    // const navMainPageLine2 = document.querySelectorAll('.nav-main-page .nav-bottom-line')[0];
    // if (navMainPageLine2.classList.contains('scaleX-0')){
    //   navMainPageLine2.classList.remove('scaleX-0');
    // }
  }
};
</script>

<style scoped>
.nav-link {
  color: #222;
}
.theme2 .nav-link {
  color: white;
}
.theme2 svg {
  fill: white !important;
}
.theme2 .nav-bottom-line {
  background-color: white;
}
.theme2 .nav-link-child {
  color: var(--color-theme2);
  /*text-shadow:0 0 1px white;*/
}
.nav-link:hover,
.nav-link:hover span {
  /*color: var(--color-theme);*/
  font-family: font-normal;
}
.nav-bottom-line {
  width: 80%;
  height: 1px;
  background-color: var(--color-theme);
  transform: scaleX(0);
  transform-origin: right;
}
.nav-main-page .nav-bottom-line {
  transform: scaleX(1);
  transform-origin: left;
}
.nav-item:hover .nav-bottom-line,
.nav-theme2 .nav-bottom-line {
  transform: scaleX(1);
}
.scaleX-0 {
  transform: scaleX(0) !important;
}
.has-children {
  position: relative;
}
.has-children ul {
  position: absolute;
  top: 100%;
  right: 40%;
  min-width: 100px;
  text-align: right;
  transform: scaleY(0);
  transform-origin: top;
}
.has-children ul::before {
  content: "";
  width: 1px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: var(--color-theme2);
}
.has-children:hover ul {
  transform: scaleY(1);
}
.navbar-nav li a span{
  color: white;
}
</style>
